import { all } from 'redux-saga/effects'
import { reducer as formReducer } from 'redux-form'
import AuthReducer from 'modules/Auth/store/reducer'
import AuthSaga from 'modules/Auth/store/saga'
import appReducer from 'modules/App/store/reducer'
import { Sagas as AppSaga } from 'modules/App/store/saga'
import { FormsReducers, FormsSagas } from 'modules/Forms'
import modalReducer from 'modules/Modal/store/reducer'
import notificationsReducer from 'modules/Notifications/store/reducer'
import NotificationsSaga from 'modules/Notifications/store/saga'
import OnboardingReducer from 'modules/Onboarding/store/reducer'
import OnboardingSaga from 'modules/Onboarding/store/saga'
import sidePanelReducer from 'modules/SidePanel/store/reducer'
import SidePanelSaga from 'modules/SidePanel/store/saga'

/**
 * Shell-слайс с reducer + saga (пары держим в синхроне здесь).
 * Импорты только через store/reducer и store/saga, не через modules/.../index.js,
 * чтобы не тянуть UI и циклические зависимости (например modules/App -> store) в bootstrap.
 */

const shellModulesWithSaga = [
  { reducerKey: 'auth', reducer: AuthReducer, saga: AuthSaga, module: 'modules/Auth' },
  { reducerKey: 'app', reducer: appReducer, saga: AppSaga, module: 'modules/App' },
  {
    reducerKey: 'notifications',
    reducer: notificationsReducer,
    saga: NotificationsSaga,
    module: 'modules/Notifications',
  },
  {
    reducerKey: 'onboarding',
    reducer: OnboardingReducer,
    saga: OnboardingSaga,
    module: 'modules/Onboarding',
  },
  { reducerKey: 'sidePanel', reducer: sidePanelReducer, saga: SidePanelSaga, module: 'modules/SidePanel' },
]

/** Shell-слайсы только с reducer (библиотека / UI state, без saga). */
const shellReducerOnly = [
  { reducerKey: 'modal', reducer: modalReducer, module: 'modules/Modal' },
  { reducerKey: 'form', reducer: formReducer },
]

/** Прокси-бандлы модулей (например modules/Forms/index.js). */
const proxyReducerMaps = [FormsReducers]
const proxySagaLists = [FormsSagas]

export const getStaticReducers = () => ({
  ...Object.fromEntries(shellModulesWithSaga.map(({ reducerKey, reducer }) => [reducerKey, reducer])),
  ...Object.fromEntries(shellReducerOnly.map(({ reducerKey, reducer }) => [reducerKey, reducer])),
  ...Object.assign({}, ...proxyReducerMaps),
})

export const staticSagas = [
  ...shellModulesWithSaga.map(({ saga }) => saga),
  ...proxySagaLists.flat(),
]

export function* rootStaticSaga() {
  yield all(staticSagas.map((saga) => saga()))
}
